import React, { useState, useRef, useImperativeHandle } from 'react';
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import styled from 'styled-components';

const StyledMenu = styled(Menu)`
  pointer-events: none;
`;

const SubMenuItemContainer = styled.div`
  pointer-events: auto;
`;

export interface NestedMenuItemProps extends Omit<MenuItemProps, 'button'> {
  parentMenuOpen?: boolean;
  className?: string;
  ref?: any;
  children?: any;
  label?: React.ReactNode;
}

const NestedMenuItem: React.FC<NestedMenuItemProps> = ({
  parentMenuOpen,
  className = '',
  label = '',
  children,
  ref,
  ...menuItemProps
}: NestedMenuItemProps) => {
  const menuItemRef = useRef();
  useImperativeHandle(ref, () => menuItemRef.current);

  const containerRef = useRef();

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const open = isSubMenuOpen && parentMenuOpen;

  const handleOpen = () => setIsSubMenuOpen(true);
  const handleClose = () => setIsSubMenuOpen(false);
  const handleFocus = (event: React.FocusEvent<HTMLElement>) => {
    if (event.target === containerRef.current) {
      setIsSubMenuOpen(true);
    }
  };

  return (
    <div ref={containerRef} onFocus={handleFocus} onMouseEnter={handleOpen} onMouseLeave={handleClose}>
      <MenuItem ref={menuItemRef} {...menuItemProps} className={className}>
        {label}
      </MenuItem>
      <StyledMenu
        open={open}
        anchorEl={menuItemRef.current}
        autoFocus={false}
        disableAutoFocus
        disableEnforceFocus
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <SubMenuItemContainer>
          {children}
        </SubMenuItemContainer>
      </StyledMenu>
    </div>
  );
};

export default React.forwardRef((props, ref) => <NestedMenuItem ref={ref} {...props} />);
